<template>
  <div class="fixed bottom-[32%] right-[20px] dg_contactus">
    <el-popover v-show="platformServiceDetail.wechatQrCode" :close-delay="0" placement="left" trigger="hover"
      popper-class="popper-dg_contactus">
      <div slot="reference">
        <p class="w-[40] h-[40] text-center leading-[40] rounded-[100%] bg-[#fff] contact_phone">
          <i class="icon t-[#3F3F3F] t-[21]">&#xe616;</i>
        </p>
      </div>
      <div class="text-center pt-[3]">
        <p><img v-if="platformServiceDetail.wechatQrCode" :src="platformServiceDetail.wechatQrCode" class="w-[80]" alt=""></p>
        <p class="pt-[3]"><span class="t-[12px] t-[#606266]">客服微信</span></p>
      </div>
    </el-popover>
    <el-popover :close-delay="0" placement="left" trigger="hover" popper-class="popper-help">
      <div slot="reference" class="mt-[18]">
        <p class="w-[40] h-[40] text-center leading-[40] rounded-[100%] bg-[#fff] contact_phone">
          <i class="icon t-[#3F3F3F] t-[18] ">&#xe721;</i>
        </p>
      </div>
      <div class="py-[8] px-[14]">
        <div class="mb-[14]">
          <p class="flex items-center">
            <i class="icon t-[#606266]">&#xe6d6;</i> <span class="t-[12px] t-[#606266] pl-[4]">固定电话</span>
          </p>
          <p class="pl-[20] pt-[4]">
            <span class="t-[14px] t-[#303133]">{{ platformServiceDetail.telephone || '-' }}</span>
          </p>
        </div>
        <div>
          <p class="flex items-center">
            <i class="icon t-[#606266]">&#xe6d7;</i> <span class="t-[12px] t-[#606266] pl-[4]">联系手机</span>
          </p>
          <p class="pl-[20] pt-[4]">
            <span class="t-[14px] t-[#303133]">{{ platformServiceDetail.mobile || '-' }}</span>
          </p>
        </div>
      </div>
    </el-popover>
  </div>
</template>
<script>
export default {
  name: "dg-contactus",
  data() {
    return {
      platformServiceDetail: {},
    }
  },
  methods: {
    getContact() {
      ajax.post({
        url: '/customer/common/platformServiceDetail',
        data: {},
        self: this,
        success: (res) => {
          if (res) {
            this.platformServiceDetail = res || {}
          }
        },
      })
    },
  },
  mounted() { },
  created() {
    this.getContact();
  },
}
</script>
<style scoped lang="less">
.contact_phone {
 // box-shadow: 0px 3px 3px 0px rgba(198, 205, 219, 0.25);
  box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.16);
  &:hover i {
    color: #fff;
  }

  &:hover {
    background: @contact_phone_gradient;
  }
}
</style>
<style lang="less">
.popper-dg_contactus {
  min-width: 95px;
}
</style>
